import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import SVG from 'components/SVG';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';

import { actions as reportsActions } from 'features/reports/redux';

import { formatNumberWithLimit } from 'shared/helpers/formatNumber';

import { getActionItems, userTypes } from '../../../data';

import './TableRow.scss';

const b = block('adm-bets-table-row-user');

const TableRow = ({ item, isWithdrawalAccess, isDepositAccess, locale, openDropdown, setOpenDropdown }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isOpen = openDropdown?.userID === item?.id && openDropdown?.isOpen;

  const lastMovementsClick = () => {
    dispatch(reportsActions.setPlayerUsername(item.username, item.role));
    history.replace(item.role === '6' ? '/reports/financial-reports/cash' : '/reports/player-reports/player-history');
  };

  return (
    <div className={b({ banned: item.isBanned })}>
      <div className={b('td')}>
        <div className={b('td-data')}>
          <SVG svgProps={{ svg: userTypes[item.role]?.icon }} className={b('td-data-icon')} />
          <div className={b('td-data-user')}>
            <span>{item.username}</span>
            <div className={b('td-data-user-type', { role: item.role })}>{locale[userTypes[item.role].type]}</div>
          </div>
        </div>
      </div>
      <div className={b('td')}>{formatNumberWithLimit(item.balance)}</div>
      <div className={b('td')}>
        <div className={b('td-buttons')}>
          {isDepositAccess && (
            <Button disabled={item.isBanned} link={`/user/deposit/${item.id}`} text={locale.deposit} />
          )}
          {isWithdrawalAccess && (
            <Button
              disabled={item.isBanned}
              link={`/user/withdrawal/${item.id}`}
              color="full-transparent"
              text={locale.withdrawal}
            />
          )}
        </div>
      </div>
      <div className={b('td')}>
        {Number(item.role) !== 3 && (
          <div className={b('td-actions')}>
            <Dropdown
              user={item}
              items={getActionItems({ role: item.role, isBanned: item.isBanned })}
              locale={locale}
              onClick={lastMovementsClick}
              isOpen={isOpen}
              changeOpen={() => setOpenDropdown({ userID: item.id, isOpen: !isOpen })}
            />
          </div>
        )}
      </div>
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TableRow;
